import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  AcquisitionStoreActions,
  AcquisitionStoreSelectors,
  AcquisitionStoreReducer,
} from "./index";
import { LandTitleDto } from "@cradua/data";

@Injectable()
export class AcquisitionFacade {
  constructor(
    private store: Store<AcquisitionStoreReducer.AcquisitionPartialState>,
  ) {}

  Acquisition$ = this.store.select(
    AcquisitionStoreSelectors.getLastInsertedValue,
  );
  AcquisitionError$ = this.store.select(
    AcquisitionStoreSelectors.getAcquisitionError,
  );
  searchedAcquisition$ = this.store.select(
    AcquisitionStoreSelectors.getSearchAcquisition,
  );

  loadRegister$ = this.store.select(
    AcquisitionStoreSelectors.getAllAcquisition,
  );

  // return this.store.select(AcquisitionStoreSelectors.getAllAcquisition);

  getselected() {
    return this.store.select(AcquisitionStoreSelectors.getSelected);
  }

  isLoadingAcquisition(query) {
    this.store.dispatch(
      AcquisitionStoreActions.fetchAcquisitionRecord({ fetch: query }),
    );
    return this.store.select(AcquisitionStoreSelectors.loadingAcquisition);
  }

  isLoadingAcquisitionById(id: string) {
    this.store.dispatch(
      AcquisitionStoreActions.fetchByIdAcquisitionRecord({ id }),
    );
    return this.store.select(AcquisitionStoreSelectors.loadingAcquisition);
  }

  get loadAcquisition() {
    this.store.dispatch(AcquisitionStoreActions.loadAcquisition());
    return this.store.select(AcquisitionStoreSelectors.getAllAcquisition);
  }

  get clearAcquisition() {
    this.store.dispatch(AcquisitionStoreActions.clearAcquisition());
    return this.store.select(AcquisitionStoreSelectors.getAllAcquisition);
  }

  fetchStudentRecord(query) {
    this.store.dispatch(
      AcquisitionStoreActions.fetchAcquisitionRecord({ fetch: query }),
    );
  }

  getAcquisitionById(id: string) {
    this.store.dispatch(
      AcquisitionStoreActions.fetchByIdAcquisitionRecord({ id }),
    );
    return this.store.select(AcquisitionStoreSelectors.getAllAcquisition);
  }

  fetchByIdStudentRecord(id: string) {
    this.store.dispatch(
      AcquisitionStoreActions.fetchByIdAcquisitionRecord({ id }),
    );
  }

  searchAcquisition(query) {
    this.store.dispatch(
      AcquisitionStoreActions.searchAcquisitionRecord({
        query,
      }),
    );
  }

  findAcquisition(query) {
    this.store.dispatch(
      AcquisitionStoreActions.searchAcquisitionIdRecord({
        query,
      }),
    );
  }

  addAcquisition(newAcquisition: LandTitleDto) {
    this.store.dispatch(
      AcquisitionStoreActions.addAcquisition({
        newAcquisition,
      }),
    );
    return this.store.select(AcquisitionStoreSelectors.loadingAcquisition);
  }

  updateAcquisition(updateAcquisition: LandTitleDto) {
    this.store.dispatch(
      AcquisitionStoreActions.updateAcquisition({
        updateAcquisition,
      }),
    );
    return this.store.select(AcquisitionStoreSelectors.loadingAcquisition);
  }

  removeAcquisition(id: string) {
    this.store.dispatch(AcquisitionStoreActions.removeAcquisition({ id }));
  }
}
